import { render, staticRenderFns } from "./AddBasketModal.vue?vue&type=template&id=fbf712c0&scoped=true"
import script from "./AddBasketModal.vue?vue&type=script&lang=js"
export * from "./AddBasketModal.vue?vue&type=script&lang=js"
import style0 from "./AddBasketModal.vue?vue&type=style&index=0&id=fbf712c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf712c0",
  null
  
)

export default component.exports